import { ReactNode } from "react";

interface Props {
	styles?: Record<string, any>;
	children: ReactNode;
}

const Tag = ({ children, styles }: Props) => {
	return (
		<div className="barcode-label" style={styles && styles}>
			<span>{children}</span>
		</div>
	);
};
export default Tag;
